const remainingBalanceReducer = (state = 0, action) => {
	switch(action.type){
	case 'SETREMBAL':	
		return action.payload;
	default:
		return state;
	}
}

export default remainingBalanceReducer;